import { useTranslation, Trans } from 'react-i18next';
import { BASE_URL } from '../Api';
import { Helmet, HelmetProvider } from "react-helmet-async";
import { PluginDownloadButtons, FreeHighlight } from '../partials';

const NotesPlugin = () => {
  const { t } = useTranslation('notes'); // Specify namespace 'notes'

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Notes - Aronium</title>
          <meta name="description" content="Keep track of sale specific details and print them in receipt and invoice using Notes plugin" />
        </Helmet>
      </HelmetProvider>

      <section className="py-8 max-w-screen-xl px-4 mx-auto">
        <div className="max-w-screen-xl mx-auto text-center">
          <h1 className="text-4xl mb-4">
            {t('heroTitle')}
          </h1>
          <p>
            {t('heroDescription')}
          </p>

          {/* Call to Action Buttons */}
          <PluginDownloadButtons
            liteUrl={`${BASE_URL}/plugins/notes/latest/Aronium.Pos.Notes.exe`}
            proUrl={`${BASE_URL}/plugins/notes/latest/Aronium.Pos.Notes.Networking.exe`} />
        </div>
      </section>

      <div className="flex flex-col text-center my-10">
        <div className="grid place-content-center justify-items-center px-4">
          <img src="/images/notes.png" className='rounded-lg xl:max-w-6xl' alt="Adding notes to the sale" />
        </div>
      </div>

      {/* Overview Section */}
      <div className="relative py-20 bg-gradient-to-r from-gray-50 to-white">
        <div className="relative max-w-7xl mx-auto text-center px-8 lg:px-12">
          <h2 className="text-5xl text-gray-800 leading-tight mb-8">
            <Trans ns='notes' i18nKey="overviewTitle" components={{ strong: <span className='font-semibold' /> }} />
          </h2>
          <p className="text-lg text-gray-600 mx-auto">
            <Trans ns='notes' i18nKey="overviewDescription" components={{ strong: <span className='font-semibold' /> }} />
          </p>
        </div>
        <FreeHighlight className="mt-12" />
      </div>

      {/* Key Features Section */}
      <div className="py-24">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          <div className="bg-white p-8 shadow-lg rounded-lg border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-800">{t('feature1Title')}</h3>
            <p className="mt-4 text-gray-600">{t('feature1Description')}</p>
          </div>
          <div className="bg-white p-8 shadow-lg rounded-lg border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-800">{t('feature2Title')}</h3>
            <p className="mt-4 text-gray-600">{t('feature2Description')}</p>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="relative bg-gradient-to-tr from-[#88b5be] to-[#a0946f] py-24 text-center text-white">
        <div className="relative max-w-6xl mx-auto px-4">
          <h2 className="text-4xl xl:text-5xl mb-6">{t('ctaTitle')}</h2>
          <p className="text-xl mb-10">
            <Trans ns='notes' i18nKey="ctaDescription" components={{ strong: <span className='font-semibold' /> }} />
          </p>
          <a
            href="https://help.aronium.com/hc/en-us/articles/4402015114514-Add-notes-to-the-sale"
            className="button-rounded-white px-12 py-4"
            target="_blank"
            rel="noreferrer">
            {t('learnMore')} <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="ml-2 w-6 h-6 transition-all">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default NotesPlugin;
